import { withAuthorization } from "../../authentication/Session/withAuthorization";
import { getAuthorizationGuard } from "../../authentication/authorizations";
import { Role } from "@farmact/model/src/model/Role";
import { lazy } from "react";
import { DefaultPage } from "../../structure/Page/DefaultPage/DefaultPage";

const RevenueDevelopmentPageContent = lazy(() => import("./RevenueDevelopmentPageContent"));

function RevenueDevelopmentPageInternal() {
    return (
        <DefaultPage>
            <RevenueDevelopmentPageContent />
        </DefaultPage>
    );
}

export const RevenueDevelopmentPage = withAuthorization(getAuthorizationGuard(Role.OWNER, Role.ADMIN))(
    RevenueDevelopmentPageInternal
);
